
// const MTK = window.MTK;
let mtkMapInstance = null;

/**
 * @param {HTMLElement} container
 * @param {[number, number]} center
 * @param {number} zoom
 */
export function initMTKMap(container, center, zoom) {
  const MTK = window.MTK;
  if (!MTK) {
    console.error("MTK not available");
    return;
  }

  if (mtkMapInstance) return;

  MTK.init({ api_key: "93563e3c-84df-435d-a44e-7a6c24e0d817" });

  

  MTK.createMap(
    container,
    {
      map: {
        mapType: "toursprung-terrain",
        location: { center, zoom, pitch: 0, bearing: 0 },
        controls: [
          [new MTK.Map3DControl({ showCompass: 1, showPitch: 1 }), "bottom-right"],
          [new MTK.StyleControl(["terrain"]), "top-right"],
          [new MTK.WeatherControl({ mode: "null"}), "top-right"],
        ],
      },
    },
    (map) => {
      mtkMapInstance = map;
      console.log(" MTK 3D map loaded");
      map.enableTerrain();

      window.mtkMap = map;

       const container = document.getElementById("weather-map-container");
      if (container) {
        container.style.background = "linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 10%, #f0f8ff 15%)";
      }
      const poiLayersToHide = [
        "poi_label_bank",
        "poi_label_peaks",
        "poi_label_alpine_hut",
        "poi_label_garden",
        "poi_label_pitch",
        "poi_toilet",
        "poi_generator",
        "poi_label_rail_station",
        "poi_label_aerialway_station_icon",
        "poi_label_subway_label",
        "poi_label_3",
        "poi_label_2",
        "poi_label_1",
        "poi_label_mountain_pass",
      ];

      // const logVisibleLayers = () => {
      //   const style = map.gl.getStyle();
      //   if (!style?.layers) return;

      //   const visibleLayers = style.layers.filter(
      //     (l) => l.layout?.visibility !== "none"
      //   );

      //   visibleLayers.forEach((layer, idx) => {
      //     console.log(`${idx}: ${layer.id} | type: ${layer.type}`);
      //   });
      // };

      const hidePOILayers = () => {
        const style = map.gl.getStyle();
        if (!style?.layers) return;

        const hidden = [];

        style.layers.forEach((layer) => {
          if (
            poiLayersToHide.includes(layer.id) &&
            layer.layout?.visibility !== "none"
          ) {
            map.gl.setLayoutProperty(layer.id, "visibility", "none");
            hidden.push(layer.id);
          }
        });
      };


      // map.once("idle", () => {
      //   logVisibleLayers();
      //   hidePOILayers();
      // });

     
      map.gl.on("styledata", () => {
        hidePOILayers();
      });
//        map.gl.on("moveend", () => {
//   const gl = map.gl;
  
//   const center = gl.getCenter(); // [lng, lat]
//   const zoom = gl.getZoom();
//   const pitch = gl.getPitch();
//   const bearing = gl.getBearing();

//   // Log detaliat
//   console.log(
//     "[MTK moveend]",
//     "zoom=", zoom.toFixed(2),
//     "| lat=", center.lat.toFixed(6),
//     "| lon=", center.lng.toFixed(6),
//     "| pitch=", pitch.toFixed(1),
//     "| bearing=", bearing.toFixed(1)
//   );
// });


       map.gl.on("move", () => {
        const pitch = map.gl.getPitch();
        const container = document.getElementById("weather-map-container");
        if (!container) return;
        let gradient;

        if (pitch >= 86) {
          gradient = "linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 30%, #f0f8ff 40%)";
        } else if (pitch >= 77) {
          gradient = "linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 20%, #f0f8ff 30%)";
        } else {
          gradient = "linear-gradient(to bottom, #d6f0ff 0%, #b0e2ff 70%, #f0f8ff  50%)";
        }
        container.style.background = gradient;

      });

    }
  );
}


export function getMTKMap() {
  return mtkMapInstance;
}


export function destroyMTKMap() {
  if (mtkMapInstance) {
    console.log("Distrug MTK map...");
    mtkMapInstance.remove();
    mtkMapInstance = null;
    console.log("Distrug MTK map...", mtkMapInstance);
  }
}
